import * as React from 'react'

import { ColorOption, Selector } from '../../options'

export interface Props {
  maskID: string
  children: React.ReactNode
}

export function makeColor (name: string, color: string) {
  class ColorComponent extends React.Component<Props> {
    render () {
      return (
        <g id={name}
           mask={`url(#${this.props.maskID})`}
           fill={color}>
          {this.props.children}
        </g>
      )
    }
  }

  const anyComponent = ColorComponent as any
  anyComponent.displayName = name
  anyComponent.optionValue = name
  return anyComponent
}

// const ColorArray = [
//   makeColor('Black', '#000000'),
//   makeColor('White', '#FFFFFF'),
//
//   makeColor('Red050', '#FFEBEE'),
//   makeColor('Red100', '#FFCDD2'),
//   makeColor('Red200', '#EF9A9A'),
//   makeColor('Red300', '#E57373'),
//   makeColor('Red400', '#EF5350'),
//   makeColor('Red500', '#F44336'),
//   makeColor('Red600', '#E53935'),
//   makeColor('Red700', '#D32F2F'),
//   makeColor('Red800', '#C62828'),
//   makeColor('Red900', '#B71C1C'),
//   makeColor('RedA100', '#FF8A80'),
//   makeColor('RedA200', '#FF5252'),
//   makeColor('RedA300', '#FF1744'),
//   makeColor('RedA400', '#D50000'),
//
//   makeColor('Pink500', '#E91E63'),
//
//   makeColor('Purple500', '#9C27B0'),
//
//   makeColor('DeepPurple500', '#673AB7'),
//
//   makeColor('Indigo500', '#3F51B5'),
//
//   makeColor('Blue500', '#2196F3'),
//
//   makeColor('LightBlue500', '#03A9F4'),
//
//   makeColor('Cyan500', '#00BCD4'),
//
//   makeColor('Teal500', '#009688'),
//
//   makeColor('Green500', '#4CAF50'),
//
//   makeColor('LightGreen500', '#8BC34A'),
//
//   makeColor('Lime500', '#CDDC39'),
//
//   makeColor('Yellow500', '#FFEB3B'),
//
//   makeColor('Amber500', '#FFC107'),
//
//   makeColor('Orange500', '#FF9800'),
//
//   makeColor('DeepOrange500', '#FF5722'),
//
//   makeColor('Brown500', '#795548'),
//
//   makeColor('BlueGrey050', '#ECEFF1'),
//   makeColor('BlueGrey100', '#CFD8DC'),
//   makeColor('BlueGrey200', '#B0BEC5'),
//   makeColor('BlueGrey300', '#90A4AE'),
//   makeColor('BlueGrey400', '#78909C'),
//   makeColor('BlueGrey500', '#607D8B'),
//   makeColor('BlueGrey600', '#546E7A'),
//   makeColor('BlueGrey700', '#455A64'),
//   makeColor('BlueGrey800', '#37474F'),
//   makeColor('BlueGrey900', '#263238'),
// ]

export const Black = makeColor('Black', '#000000')
export const White = makeColor('White', '#FFFFFF')

// Red
export const Red050 = makeColor('Red050', '#FFEBEE')
export const Red100 = makeColor('Red100', '#FFCDD2')
export const Red200 = makeColor('Red200', '#EF9A9A')
export const Red300 = makeColor('Red300', '#E57373')
export const Red400 = makeColor('Red400', '#EF5350')
export const Red500 = makeColor('Red', '#F44336')
export const Red600 = makeColor('Red600', '#E53935')
export const Red700 = makeColor('Red700', '#D32F2F')
export const Red800 = makeColor('Red800', '#C62828')
export const Red900 = makeColor('Red900', '#B71C1C')
export const RedA100 = makeColor('RedA100', '#FF8A80')
export const RedA200 = makeColor('RedA200', '#FF5252')
export const RedA300 = makeColor('RedA300', '#FF1744')
export const RedA400 = makeColor('RedA400', '#D50000')

// Pink
export const Pink500 = makeColor('Pink', '#E91E63')

// Purple
export const Purple500 = makeColor('Purple', '#9C27B0')

// DeepPurple
export const DeepPurple500 = makeColor('DeepPurple', '#673AB7')

// Indigo
export const Indigo500 = makeColor('Indigo', '#3F51B5')

// Blue
export const Blue500 = makeColor('Blue', '#2196F3')

// LightBlue
export const LightBlue500 = makeColor('LightBlue', '#03A9F4')

// Cyan
export const Cyan500 = makeColor('Cyan', '#00BCD4')

// Teal
export const Teal500 = makeColor('Teal', '#009688')

// Green
export const Green500 = makeColor('Green', '#4CAF50')

// LightGreen
export const LightGreen500 = makeColor('LightGreen', '#8BC34A')

// Lime
export const Lime500 = makeColor('Lime', '#CDDC39')

// Yellow
export const Yellow500 = makeColor('Yellow', '#FFEB3B')

// Amber
export const Amber500 = makeColor('Amber', '#FFC107')

// Orange
export const Orange500 = makeColor('Orange', '#FF9800')

// DeepOrange
export const DeepOrange500 = makeColor('DeepOrange', '#FF5722')

// Brown
export const Brown500 = makeColor('Brown', '#795548')

// Gray
export const Gray500 = makeColor('Gray', '#9E9E9E')
export const Gray800 = makeColor('GrayDark', '#424242')

// BlueGrey
export const BlueGrey050 = makeColor('BlueGrey050', '#ECEFF1')
export const BlueGrey100 = makeColor('BlueGrey100', '#CFD8DC')
export const BlueGrey200 = makeColor('BlueGrey200', '#B0BEC5')
export const BlueGrey300 = makeColor('BlueGrey300', '#90A4AE')
export const BlueGrey400 = makeColor('BlueGrey400', '#78909C')
export const BlueGrey500 = makeColor('BlueGrey', '#607D8B')
export const BlueGrey600 = makeColor('BlueGrey600', '#546E7A')
export const BlueGrey700 = makeColor('BlueGrey700', '#455A64')
export const BlueGrey800 = makeColor('BlueGrey800', '#37474F')
export const BlueGrey900 = makeColor('BlueGrey900', '#263238')

export default class Color extends React.Component<Props> {
  render () {
    return (
      <Selector option={ColorOption} defaultOption={Gray800}>
        <Black maskID={this.props.maskID}>{this.props.children}</Black>
        <White maskID={this.props.maskID}>{this.props.children}</White>

        {/*<Red050 maskID={this.props.maskID}>{this.props.children}</Red050>*/}
        {/*<Red100 maskID={this.props.maskID}>{this.props.children}</Red100>*/}
        {/*<Red200 maskID={this.props.maskID}>{this.props.children}</Red200>*/}
        {/*<Red300 maskID={this.props.maskID}>{this.props.children}</Red300>*/}
        {/*<Red400 maskID={this.props.maskID}>{this.props.children}</Red400>*/}
        <Red500 maskID={this.props.maskID}>{this.props.children}</Red500>
        {/*<Red600 maskID={this.props.maskID}>{this.props.children}</Red600>*/}
        {/*<Red700 maskID={this.props.maskID}>{this.props.children}</Red700>*/}
        {/*<Red800 maskID={this.props.maskID}>{this.props.children}</Red800>*/}
        {/*<Red900 maskID={this.props.maskID}>{this.props.children}</Red900>*/}
        {/*<RedA100 maskID={this.props.maskID}>{this.props.children}</RedA100>*/}
        {/*<RedA200 maskID={this.props.maskID}>{this.props.children}</RedA200>*/}
        {/*<RedA300 maskID={this.props.maskID}>{this.props.children}</RedA300>*/}
        {/*<RedA400 maskID={this.props.maskID}>{this.props.children}</RedA400>*/}

        <Pink500 maskID={this.props.maskID}>{this.props.children}</Pink500>

        <Purple500 maskID={this.props.maskID}>{this.props.children}</Purple500>

        <DeepPurple500 maskID={this.props.maskID}>{this.props.children}</DeepPurple500>

        <Indigo500 maskID={this.props.maskID}>{this.props.children}</Indigo500>

        <Blue500 maskID={this.props.maskID}>{this.props.children}</Blue500>

        <LightBlue500 maskID={this.props.maskID}>{this.props.children}</LightBlue500>

        <Cyan500 maskID={this.props.maskID}>{this.props.children}</Cyan500>

        <Teal500 maskID={this.props.maskID}>{this.props.children}</Teal500>

        <Green500 maskID={this.props.maskID}>{this.props.children}</Green500>

        <LightGreen500 maskID={this.props.maskID}>{this.props.children}</LightGreen500>

        <Lime500 maskID={this.props.maskID}>{this.props.children}</Lime500>

        <Yellow500 maskID={this.props.maskID}>{this.props.children}</Yellow500>

        <Amber500 maskID={this.props.maskID}>{this.props.children}</Amber500>

        <Orange500 maskID={this.props.maskID}>{this.props.children}</Orange500>

        <DeepOrange500 maskID={this.props.maskID}>{this.props.children}</DeepOrange500>

        <Brown500 maskID={this.props.maskID}>{this.props.children}</Brown500>

        <Gray500 maskID={this.props.maskID}>{this.props.children}</Gray500>
        <Gray800 maskID={this.props.maskID}>{this.props.children}</Gray800>

        {/*<BlueGrey050 maskID={this.props.maskID}>{this.props.children}</BlueGrey050>*/}
        {/*<BlueGrey100 maskID={this.props.maskID}>{this.props.children}</BlueGrey100>*/}
        {/*<BlueGrey200 maskID={this.props.maskID}>{this.props.children}</BlueGrey200>*/}
        {/*<BlueGrey300 maskID={this.props.maskID}>{this.props.children}</BlueGrey300>*/}
        {/*<BlueGrey400 maskID={this.props.maskID}>{this.props.children}</BlueGrey400>*/}
        <BlueGrey500 maskID={this.props.maskID}>{this.props.children}</BlueGrey500>
        {/*<BlueGrey600 maskID={this.props.maskID}>{this.props.children}</BlueGrey600>*/}
        {/*<BlueGrey700 maskID={this.props.maskID}>{this.props.children}</BlueGrey700>*/}
        {/*<BlueGrey800 maskID={this.props.maskID}>{this.props.children}</BlueGrey800>*/}
        {/*<BlueGrey900 maskID={this.props.maskID}>{this.props.children}</BlueGrey900>*/}
      </Selector>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/bot/color/Color.tsx